import { render, staticRenderFns } from "./TheMainAsideBar.vue?vue&type=template&id=a6a5ce8a&"
import script from "./TheMainAsideBar.vue?vue&type=script&lang=js&"
export * from "./TheMainAsideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports